export default __webpack_public_path__ + "static/media/Concordia.a788c141.png";